module.exports = __webpack_public_path__ + "img/health_wellbeing.4e6d404f.svg";